import { httpClient } from '@/shell';
import type {
  PublicEvent,
  PublicItemSummary,
  PublicItemSummaryPage,
  PublicItemDetail,
  Category,
  BidCountsResponse,
} from '@neon-one/auctions-types';

export interface CatalogQuery {
  category?: number;
  q?: string;
  minBid?: number;
  maxBid?: number;
  cursor?: string;
  limit?: number;
}

export const catalogApi = {
  async event(slug: string): Promise<PublicEvent> {
    const resp = await httpClient().get<PublicEvent>(
      `/public/events/${encodeURIComponent(slug)}`,
    );
    return resp.data;
  },

  async items(slug: string, query: CatalogQuery = {}): Promise<PublicItemSummaryPage> {
    const params: Record<string, string | number> = {};
    if (query.category != null) params.category = query.category;
    if (query.q) params.q = query.q;
    if (query.minBid != null) params.minBid = query.minBid;
    if (query.maxBid != null) params.maxBid = query.maxBid;
    if (query.cursor) params.cursor = query.cursor;
    if (query.limit != null) params.limit = query.limit;
    const resp = await httpClient().get<PublicItemSummaryPage>(
      `/public/events/${encodeURIComponent(slug)}/items`,
      { params },
    );
    return resp.data;
  },

  async itemDetail(slug: string, itemId: number): Promise<PublicItemDetail> {
    const resp = await httpClient().get<PublicItemDetail>(
      `/public/events/${encodeURIComponent(slug)}/items/${itemId}`,
    );
    return resp.data;
  },

  async bundleDetail(slug: string, bundleId: number): Promise<PublicItemDetail> {
    const resp = await httpClient().get<PublicItemDetail>(
      `/public/events/${encodeURIComponent(slug)}/bundles/${bundleId}`,
    );
    return resp.data;
  },

  async bidCounts(slug: string): Promise<BidCountsResponse> {
    const resp = await httpClient().get<BidCountsResponse>(
      `/public/events/${encodeURIComponent(slug)}/items/bid-counts`,
    );
    return resp.data;
  },

  async categories(slug: string): Promise<Category[]> {
    const resp = await httpClient().get<Category[]>(
      `/public/events/${encodeURIComponent(slug)}/categories`,
    );
    return resp.data;
  },
};

export type { PublicEvent, PublicItemSummary, PublicItemDetail, Category };
